'use client';

import { useEffect, useState } from 'react';
import { isWebpFile, readWebpSource, type DecodedWebpSource } from '@/lib/browser-webp-tools';

export type LoadedWebpSource = DecodedWebpSource & {
  previewUrl: string;
};

export function useLoadedWebpSource() {
  const [source, setSource] = useState<LoadedWebpSource | null>(null);

  useEffect(() => {
    return () => {
      if (source?.previewUrl) {
        URL.revokeObjectURL(source.previewUrl);
      }
    };
  }, [source]);

  async function loadSource(file: File) {
    if (!isWebpFile(file)) {
      throw new Error('Choose one WebP file for this tool.');
    }

    const decoded = await readWebpSource(file);

    setSource((current) => {
      if (current?.previewUrl) {
        URL.revokeObjectURL(current.previewUrl);
      }

      return {
        ...decoded,
        previewUrl: URL.createObjectURL(file),
      };
    });
  }

  function clearSource() {
    setSource((current) => {
      if (current?.previewUrl) {
        URL.revokeObjectURL(current.previewUrl);
      }

      return null;
    });
  }

  return {
    source,
    loadSource,
    clearSource,
  };
}
